import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { UserService } from '../../api/services/user.service';
import { PreferencesService } from '../../api/services/preferences.service';

@Component({
  selector: 'app-permission-wrapper',
  templateUrl: './permission-wrapper.component.html',
  styleUrls: ['./permission-wrapper.component.scss']
})
export class PermissionWrapperComponent implements OnInit {

  @Input() roles: string[];

  @Input() context: string;

  @Input() visibility?: boolean;

  isVisible = false;

  constructor(private authService: AuthService,
    private userService: UserService,
    private preferencesService: PreferencesService
  ) { }

  ngOnInit() {
    if (typeof this.visibility === 'boolean') {
      this.isVisible = this.visibility;
      return;
    }

    if (this.context === 'MARKET') {
      this.preferencesService.getPreferences('USER', this.authService.getUserId())
      .subscribe(prefs => {
        const currentMarket = prefs['current-market'].Value;
        this.authService.getUserRolesInContext(`${this.context}~${currentMarket}`).subscribe(roles => {
          this.isVisible = this.roles.every(r => roles.includes(r));
        });
      });
    } else {
      this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
        const context = `ORGANIZATION~${user['Organization ID']}`;
        this.authService.getUserRolesInContext(context).subscribe(roles => {
          this.isVisible = this.roles.every(r => roles.includes(r));
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/permission-wrapper/permission-wrapper.component.ts